import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const PaddingTopIcon = (props?: SvgProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path
      d="M17.5 2.5H2.5M10 17.5V5.83333M10 5.83333L4.16667 11.6667M10 5.83333L15.8333 11.6667"
      stroke="var(--color-iconTertiary)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
